import type { ReactNode } from 'react'
import styles from './DocumentDetailsTab.module.css'

interface DocumentDetailsTabProps {
  children: ReactNode
}

export function DocumentDetailsTab({ children }: DocumentDetailsTabProps) {
  return <div className={styles.root}>{children}</div>
}
